import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Switcher} from "@pg-design/switcher-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT,
    HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPE_ICONS,
    HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPES
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {HomeMatchPreferencesSurveyCard} from "../HomeMatchPreferencesSurveyCard";

const {SECONDARY_MARKET} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

export const HomeMatchPreferencesSurveyPropertyTypeFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const propertyType = watch("propertyType");
    const secondaryMarket = watch("secondaryMarket");

    return (
        <div className={fieldsStyle}>
            <div className={propertyTypeGridStyle}>
                {HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPES.map((option) => {
                    const Icon = HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPE_ICONS[option.value];

                    return (
                        <HomeMatchPreferencesSurveyCard
                            icon={<Icon size="6.4" />}
                            isSelected={propertyType === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("propertyType", propertyType === option.value ? null : option.value, {shouldDirty: true})}
                            propertyType
                        />
                    );
                })}
            </div>

            <Switcher
                checked={secondaryMarket}
                checkedColor="var(--colors-secondary)"
                id="home-match-preferences-secondary-market"
                labelContent={
                    <Text preserveFontSize variant="body_copy_2">
                        {SECONDARY_MARKET}
                    </Text>
                }
                onChange={(checked) => setValue("secondaryMarket", checked, {shouldDirty: true})}
                variant="big"
                wrapperClassName={secondaryMarketStyle}
            />
        </div>
    );
};

const fieldsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3
});

const propertyTypeGridStyle = css({
    display: "grid",
    gap: 1,
    gridTemplateColumns: "1fr 1fr"
});

const secondaryMarketStyle = css({
    justifyContent: "space-between",
    width: "100%"
});
import {css} from "@panda/css";

import {useFormContextRHF} from "@pg-design/rhf-components-module";
import {Switcher} from "@pg-design/switcher-module";
import {Text} from "@pg-design/text-module";

import {
    HOME_MATCH_PREFERENCES_SURVEY_CONTENT,
    HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPE_ICONS,
    HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPES
} from "../../../constants/preferences/home_match_preferences_survey_content";
import {IHomeMatchPreferencesSurveyForm} from "../../../types/home_match_preferences";
import {HomeMatchPreferencesSurveyCard} from "../HomeMatchPreferencesSurveyCard";

const {SECONDARY_MARKET} = HOME_MATCH_PREFERENCES_SURVEY_CONTENT;

export const HomeMatchPreferencesSurveyPropertyTypeFields = () => {
    const {setValue, watch} = useFormContextRHF<IHomeMatchPreferencesSurveyForm>();
    const propertyType = watch("propertyType");
    const secondaryMarket = watch("secondaryMarket");

    return (
        <div className={fieldsStyle}>
            <div className={propertyTypeGridStyle}>
                {HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPES.map((option) => {
                    const Icon = HOME_MATCH_PREFERENCES_SURVEY_PROPERTY_TYPE_ICONS[option.value];

                    return (
                        <HomeMatchPreferencesSurveyCard
                            icon={<Icon size="6.4" />}
                            isSelected={propertyType === option.value}
                            key={option.value}
                            label={option.label}
                            onSelect={() => setValue("propertyType", propertyType === option.value ? null : option.value, {shouldDirty: true})}
                            propertyType
                        />
                    );
                })}
            </div>

            <Switcher
                checked={secondaryMarket}
                checkedColor="var(--colors-secondary)"
                id="home-match-preferences-secondary-market"
                labelContent={
                    <Text preserveFontSize variant="body_copy_2">
                        {SECONDARY_MARKET}
                    </Text>
                }
                onChange={(checked) => setValue("secondaryMarket", checked, {shouldDirty: true})}
                variant="big"
                wrapperClassName={secondaryMarketStyle}
            />
        </div>
    );
};

const fieldsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3
});

const propertyTypeGridStyle = css({
    display: "grid",
    gap: 1,
    gridTemplateColumns: "1fr 1fr"
});

const secondaryMarketStyle = css({
    justifyContent: "space-between",
    width: "100%"
});
